import {IsEnum, IsNotEmpty, ValidateIf} from "class-validator";
import {PersonaTheme} from "../../enums/personaTheme.enum";
import CategoryAnswer from "../answer/categoryAnswer.model";
import {MeetsURLCriteria} from "../../validators/meetsURLCriteria";
import {FoundMatchingURL} from "../../validators/foundMatchingURL.validator";

class PersonaCreateModel {

    @ValidateIf(o => o.isLoggedIn)
    @IsNotEmpty({message: "Please enter a title"})
    displayName: string;

    isLoggedIn?: boolean;

    @ValidateIf(o => o.isLoggedIn)
    @FoundMatchingURL({message: "This URL is unavailable, try something else"})
    @MeetsURLCriteria({message: "Please enter a URL that meets the requirements"})
    customUrlPathName?: string;

    @IsNotEmpty({message: "Select an option"})
    @IsEnum(PersonaTheme)
    theme: PersonaTheme;

    answers: {
        [key: string] : CategoryAnswer;
    };
}

export { PersonaCreateModel }